module.exports = __webpack_public_path__ + "static/media/sidebar4.84c6473a.svg";